const LOGO_LIGHT = '/Fulllogo light png.png';
const LOGO_DARK = '/Fulllogo icon dark.png';

const Logo = ({ theme = 'light' }) => {
  const logoSrc = theme === 'dark' ? LOGO_DARK : LOGO_LIGHT;

  return (
    <div className="brand">
      <img src={logoSrc} alt="GlamiFy Events" className="brand-image" />
    </div>
  );
};

export default Logo;
